import './Loading.scss'
import React, { Component } from 'react'
import gif from '../assets/ConnectSlack.gif'

class Loading extends Component {
  constructor (props) {
    super(props)
    this.startTimer = this.startTimer.bind(this)
    this.state = { loading: props.loading }
  }

  startTimer () {
    this.timer = setTimeout(() => {
      this.timer = null
      if (!this.props.loading) {
        this.setState({ loading: false })
      }
    }, 2000)
  }

  componentDidMount () {
    if (this.state.loading) {
      this.startTimer()
    }
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  componentWillReceiveProps ({ loading }) {
    if (loading !== this.props.loading) {
      if (loading) {
        this.setState({ loading: true })
        this.startTimer()
      } else if (!this.timer) {
        this.setState({ loading: false })
      }
    }
  }

  render () {
    if (!this.state.loading) {
      return null
    }
    return (
      <div className='Loading'>
        <img src={gif} alt='loading' />
      </div>
    )
  }
}

Loading.displayName = 'Loading'

export default Loading



// WEBPACK FOOTER //
// ./src/lib/Loading.js